import React from 'react'
import { useTranslation } from 'lib/i18n'

import ProfileSidescroll from 'components/ProfileSidescroll/ProfileSidescroll'
import useRecommended from 'hooks/useRecommended'

interface RecommendedProfileCollectionProps {
  market: string
  profileId: string
}

const RecommendedProfileCollection: React.FC<
  RecommendedProfileCollectionProps
> = ({ market, profileId }) => {
  const { t } = useTranslation()

  const { recommendedCollection, loading } = useRecommended({
    marketId: market,
    profileId,
  })

  const titleComp = (
    <h2>{t('RelatedProfiles.title1', 'You might also like')}</h2>
  )

  if (loading || !recommendedCollection || recommendedCollection.length === 0) {
    return null
  }

  return (
    <>
      <ProfileSidescroll
        title={titleComp}
        profileProducts={recommendedCollection}
      />
    </>
  )
}

export default RecommendedProfileCollection
